import { render, staticRenderFns } from "./DesignLibrary.vue?vue&type=template&id=44a7f080&scoped=true"
import script from "./DesignLibrary.vue?vue&type=script&lang=js"
export * from "./DesignLibrary.vue?vue&type=script&lang=js"
import style0 from "./DesignLibrary.vue?vue&type=style&index=0&id=44a7f080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a7f080",
  null
  
)

export default component.exports